import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('xai_access_token'));

  const login = (accessToken, refreshToken) => {
    localStorage.setItem('xai_access_token', accessToken);
    if (refreshToken) localStorage.setItem('xai_refresh_token', refreshToken);
    setToken(accessToken);
  };

  const logout = () => {
    localStorage.removeItem('xai_access_token');
    localStorage.removeItem('xai_refresh_token');
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
